document.addEventListener("ajaxsuccess", function(event) {
	let data = event.detail.responseJSON;
	if (!data) {
		return;
	}

	if (data.redirect_url) {
		window.location = data.redirect_url;
	}
	else if (data.replace_url) {
		window.history.pushState({}, "", data.replace_url);
	}
	else if (data.download_url) {
		let link = document.createElement("a");
		link.href = data.download_url;
		link.target = "_blank";
		link.click();
	}
});